import { cleaningTheme } from 'theme/cleaningTheme';
import { securityTheme } from 'theme/securityTheme';
import { maintenanceTheme } from './maintenanceTheme';
import { darkTheme } from './darkTheme';

export const themeNames = {
  CLEANING: { id: 'CLEANING', name: 'Cleaning' },
  MAINTENANCE: { id: 'MAINTENANCE', name: 'Maintenance' },
  SECURITY: { id: 'SECURITY', name: 'Security' },
  DARK: { id: 'DARK', name: 'Dark' },
};

const themeMap = {
  [themeNames.CLEANING.id]: cleaningTheme,
  [themeNames.SECURITY.id]: securityTheme,
  [themeNames.MAINTENANCE.id]: maintenanceTheme,
  [themeNames.DARK.id]: darkTheme,
};

export function getThemeByName(theme) {
  return themeMap[theme];
}
